import { useAuth } from '../contexts/SupabaseAuthContext';

// KAN-3113: thin wrapper around the auth context's already-plumbed `isAdmin`
// boolean. Lives next to the rest of the hooks for discoverability.
//
// The DB Analyst confirmed (sesn_011CankJ8tSuRMbpCPky1MKo, 2026-05-07) that
// `is_admin()` does a live DB lookup against `public.users.is_admin` and is
// NOT injected into the JWT — so reading from the auth context (which fetches
// the public.users row on session change) is the canonical path. Saves every
// admin-gated component from re-deriving the boolean.
export function useIsAdmin(): { isAdmin: boolean; loading: boolean } {
  const { isAdmin, loading, hasSession, user } = useAuth();
  // Treat "session present, profile in flight" as still loading so callers
  // don't briefly render the non-admin path during rehydration.
  return {
    isAdmin,
    loading: loading || (hasSession && !user),
  };
}

export default useIsAdmin;
